__turbopack_context__.v({
  "card": "PerspectiveListing-module-scss-module__wmFfGG__card",
  "grid": "PerspectiveListing-module-scss-module__wmFfGG__grid",
  "listings": "PerspectiveListing-module-scss-module__wmFfGG__listings",
  "loadMore": "PerspectiveListing-module-scss-module__wmFfGG__loadMore",
  "stack-module-0": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-0",
  "stack-module-1": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-1",
  "stack-module-10": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-10",
  "stack-module-11": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-11",
  "stack-module-12": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-12",
  "stack-module-13": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-13",
  "stack-module-14": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-14",
  "stack-module-15": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-15",
  "stack-module-16": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-16",
  "stack-module-17": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-17",
  "stack-module-18": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-18",
  "stack-module-19": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-19",
  "stack-module-2": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-2",
  "stack-module-20": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-20",
  "stack-module-3": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-3",
  "stack-module-4": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-4",
  "stack-module-5": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-5",
  "stack-module-6": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-6",
  "stack-module-7": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-7",
  "stack-module-8": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-8",
  "stack-module-9": "PerspectiveListing-module-scss-module__wmFfGG__stack-module-9",
  "z-base": "PerspectiveListing-module-scss-module__wmFfGG__z-base",
  "z-content": "PerspectiveListing-module-scss-module__wmFfGG__z-content",
  "z-footer": "PerspectiveListing-module-scss-module__wmFfGG__z-footer",
  "z-header": "PerspectiveListing-module-scss-module__wmFfGG__z-header",
  "z-hero": "PerspectiveListing-module-scss-module__wmFfGG__z-hero",
  "z-logo": "PerspectiveListing-module-scss-module__wmFfGG__z-logo",
  "z-logo-effect": "PerspectiveListing-module-scss-module__wmFfGG__z-logo-effect",
  "z-navigation": "PerspectiveListing-module-scss-module__wmFfGG__z-navigation",
  "z-sub": "PerspectiveListing-module-scss-module__wmFfGG__z-sub",
});
